import Helmet from 'react-helmet';
// import styles from './index.module.scss';

const Terms = () => {
  return (
    <>
      <Helmet title="裝置確認" />
      <div style={{
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            padding: '20px',
            backgroundColor: '#5FC17F',
            fontWeight: '500',
            lineHeight: '30px',
            color: '#ffffff',
        }}>
            {/* <div>
                <img src={'/logo.svg'} style={{
                    width: '200px',
                    paddingBottom: '10px'
                }} alt="packageplus_logo" />
            </div> */}
            <h1>不支援桌上型電腦</h1>
            <p>為了確保最佳使用體驗，請使用手機或平板開啟此應用程式。</p>
            {/* <div style={{
                paddingTop: '30px'
            }}>
                <img src={'/workshop_qr.jpg'} style={{
                    width: '200px',
                    height: '200px'
                }} alt="packageplus_logo" />
            </div> */}
        </div>
    </>
  );
};
export default Terms;
